/**
 * Returns whether the person makes too much money to continue the interview or not.
 * @param householdMemberCount Number of people in the patient's household
 * @param householdIncome Total ANNUAL household income of the patient
 * @param hasChildren Whether the patient has children
 * @param fplValues FPL values for the state/country
 * @returns {boolean} Whether it is worth continuing the interview.
 */
export function shouldContinueInterviewAtPiGate({ householdMemberCount, householdIncome, hasChildren }, fplValues, isPregnantMinor,maxFPL) {
    if (!isNumber(householdMemberCount)) {
        householdMemberCount = 1;
    }

    if (!isNumber(householdIncome)) {
        return true;
    }

    if (householdMemberCount > 4) {
        return true;
    }

    const fplForHouseholdSize = fplValues[householdMemberCount.toString()];

    if (fplForHouseholdSize == null) {
        throw new Error("Unknown FPL value");
    }

    if(isPregnantMinor){
        return true
    }

    const maxIncome = fplForHouseholdSize * (maxFPL?maxFPL:2.51 )* 12;

    const correctedHouseholdIncome = 1.05 * householdIncome;
    return correctedHouseholdIncome < maxIncome;
}

function isNumber(value) {
    return !isNaN(parseFloat(value));
}
